// Client-side domain utilities
// This file is separate from domain.ts to avoid conflicts with next/headers

/**
 * Client-side version of isHostDomain - works in Client Components
 * Uses window.location instead of next/headers
 */
export function isHostDomainClient(): boolean {
    if (typeof window === 'undefined') {
        // We're on the server, can't use window
        return false
    }

    try {
        const currentOrigin = window.location.origin
        const hostDomain = process.env.NEXT_PUBLIC_HOST_DOMAIN || 'https://disporty.com'
        return currentOrigin === hostDomain
    } catch (error) {
        console.error('Error in isHostDomainClient:', error)
        return false
    }
}

export function getCurrentDomainClient(): string {
    if (typeof window === 'undefined') {
        return process.env.NEXT_PUBLIC_HOST_DOMAIN || 'https://disporty.com'
    }

    return window.location.origin
} 